import type { Container } from '@nine7soft/react-di';
import { TransportTicketPickerClient } from '../services/TransportTicketPickerClient';
import axios from 'axios';
import type { AxiosInstance } from 'axios';
//import { TransportTicketPickerClientMockup } from '../services/TransportTicketPickerClientMockup';

export const diConfig = {
    apiClient: (container: Container) => {
        /* if (process.env.NODE_ENV === 'development') {
            const apiClient = new TransportTicketPickerClientMockup();
            return apiClient;
        } */

        const httpClient = container.get('httpClient');
        const apiClient = new TransportTicketPickerClient(httpClient);
        return apiClient;
    },
    httpClient: (container: Container) => {
        let httpClient: AxiosInstance;
        httpClient = axios.create({
            baseURL: process.env.REACT_APP_BASE_API_URL,
            responseType: 'json',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
        });

        httpClient.interceptors.response.use(
            (response) => {
                return response;
            },
            (error) => {
                return Promise.reject(error);
            },
        );

        return httpClient;
    },
};
